module.exports = __webpack_public_path__ + "img/Kieran Tierney.9ad053f1.png";